import { Form, FormList, FormSubtypeEnum, FormTypeEnum, TemplateOrder } from '@dev/ee-api/ee-api-models';
import { Action } from 'redux';

interface FormListState {
    loadingForms?: boolean;
    formList?: Form[];
    limit?: number;
    page?: number;
    count?: number;
    formsCount?: number;
    globalFormsCount?: number;
    DeletingForm?: boolean;
    name?: string;
    form?: Form;
    formsToDelete?: Array<string>;
    pageToLoad?: any;
    ispublic?: boolean;
    haveClassicForms?: boolean;
}

export enum FormActionTypes {
    LOADING_START = '@@formList/LOADING_START',
    LOADING_SUCCESS = '@@formList/LOADING_SUCCESS',
    LOADING_ERROR = '@@formList/LOADING_ERROR',
    DELETE_START = '@@formList/DELETE_START',
    DELETE_SUCCESS = '@@formList/DELETE_SUCCESS',
    DELETE_ERROR = '@@formList/DELETE_ERROR',
    DELETE_ARRAY_START = '@@formList/DELETE_ARRAY_START',
    DELETE_ARRAY_SUCCESS = '@@formList/DELETE_ARRAY_SUCCESS',
    DELETE_ARRAY_ERROR = '@@formList/DELETE_ARRAY_ERROR',
    COPY_START = '@@formList/COPY_START',
    COPY_SUCCESS = '@@formList/COPY_SUCCESS',
    CHECK_IF_HAVE_CLASSIC_FORMS_START = '@@formList/CHECK_IF_HAVE_CLASSIC_FORMS_START',
    CHECK_IF_HAVE_CLASSIC_FORMS_SUCCESS = '@@formList/CHECK_IF_HAVE_CLASSIC_FORMS_SUCCESS',
    CHECK_IF_HAVE_CLASSIC_FORMS_ERROR = '@@formList/CHECK_IF_HAVE_CLASSIC_FORMS_ERROR',
}

export interface LoadingFormsStartAction extends Action {
    type: FormActionTypes.LOADING_START;
    payload: {
        page: number;
        limit: number;
        loadingForms: boolean;
        formTypes: FormTypeEnum[];
        formSubtypes: FormSubtypeEnum[];
        search: string;
        formsOrder: TemplateOrder;
    };
}

export interface LoadingFormsSuccessAction extends Action {
    type: FormActionTypes.LOADING_SUCCESS;
    payload: {
        loadingForms: boolean;
        formsCount: number;
        globalFormsCount: number;
        formList: FormList;
    };
}

export interface LoadingFormsErrorAction extends Action {
    type: FormActionTypes.LOADING_ERROR;
    payload: {
        loadingForms: boolean;
    };
}

export interface CheckIfHaveClassicFormsStartAction extends Action {
    type: FormActionTypes.CHECK_IF_HAVE_CLASSIC_FORMS_START;
}

export interface CheckIfHaveClassicFormsSuccessAction extends Action {
    type: FormActionTypes.CHECK_IF_HAVE_CLASSIC_FORMS_SUCCESS;
    payload: {
        haveClassicForms: boolean;
    };
}

export interface CheckIfHaveClassicFormsErrorAction extends Action {
    type: FormActionTypes.CHECK_IF_HAVE_CLASSIC_FORMS_ERROR;
}

export interface FormDeleteStartAction extends Action {
    type: FormActionTypes.DELETE_START;
    payload: {
        formName: string;
        loadingForms: boolean;
    };
}

export interface FormDeleteSuccessAction extends Action {
    type: FormActionTypes.DELETE_SUCCESS;
    payload: {
        formName: string;
        loadingForms: boolean;
    };
}

export interface FormDeleteErrorAction extends Action {
    type: FormActionTypes.DELETE_ERROR;
    payload: {
        formName: string;
        loadingForms: boolean;
    };
}

export interface ArrayOfFormsDeleteStartAction extends Action {
    type: FormActionTypes.DELETE_ARRAY_START;
    payload: {
        formNames: Array<string>;
        loadingForms: boolean;
    };
}

export interface ArrayOfFormsDeleteSuccessAction extends Action {
    type: FormActionTypes.DELETE_ARRAY_SUCCESS;
    payload: {
        formNames: Array<string>;
        loadingForms: boolean;
    };
}

export interface ArrayOfFormsDeleteErrorAction extends Action {
    type: FormActionTypes.DELETE_ARRAY_ERROR;
    payload: {
        formNames: Array<string>;
        loadingForms: boolean;
    };
}

export interface CopyFormStartAction extends Action {
    type: FormActionTypes.COPY_START;
    payload: {
        formName: string;
    };
}

export { FormListState };
